import { useParams } from 'react-router-dom';
import { useGetBwgsurveyQuery } from './BWGSurveySlice';

const BWGSurveyDetail = () => {
    const { id } = useParams();

    const {
        data: BWGSurvey
    } = useGetBwgsurveyQuery();
    // console.log("BWGSurvey", BWGSurvey);

    return (
        <>
            <div className='container-fluid p-4'>
                <div className='row d-flex justify-content-between m-3'>
                    <h4 className='col-5'>
                        BWG Survey Detail
                    </h4>
                    {/* <button className='col-5 col-sm-3 col-md-2 col-lg-1 btn btn-ff9b44 btn-round'
                        type="button"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#compalinWebAction"
                        aria-controls="compalinWebAction"
                    >Action</button> */}
                </div>
                {/* <ComplainAdminAction complainAdmin={complainAdmin}/> */}
                {
                    BWGSurvey.map((e) =>
                        id == e?.id ? (
                            <div key={e?.c_id} className='row card card-body p-3'  >
                                <p className='col-12'><b>Property Name :</b> <span>{e?.property_name}</span></p>
                                <p className='col-12'><b>Contact Number :</b> <span>{e?.contact_number}</span></p>
                                <p className='col-12'><b>Contact Name :</b> <span>{e?.contact_name}</span></p>
                                <p className='col-12'><b>Address :</b> <span>{e?.address}</span></p>
                                <p className='col-12'><b>Visit Reson :</b> <span>{e?.visit_reson}</span></p>
                                <p className='col-12'><b>Waste Generation Capacity :</b> <span>{e?.waste_generation_capacity}</span></p>
                                <p className='col-12'><b>Staying Capacity :</b> <span>{e?.staying_capacity}</span></p>
                                <p className='col-12'><b>Restaurant :</b> <span>{e?.is_restaurant === 1 ? "Yes" : "No"}</span></p>
                                <p className='col-12'><b>Compose Machine :</b> <span>{e?.is_compose_machine === 1 ? "yes" : " No"}</span></p>
                                <p className='col-12'><b>Current Solution :</b> <span>{e?.current_solution}</span></p>
                                <p className='col-12'><b>Location :</b> <span>
                                    <a className="p-1 rounded border border-success" href={`https://www.google.com/maps?q=${e?.location.x},${e?.location.y}`} title="Google Map" target="blank">
                                        <i class="fa-solid fa-location-dot"></i>
                                    </a>
                                </span> </p>
                            </div>
                        ) : null
                    )
                }
            </div>
        </>
    );
}

export default BWGSurveyDetail;
